/* eslint-disable no-negated-condition */

import { type InitialStateLoaderPayoutSetup_Query } from '#app/__generated__/relay/InitialStateLoaderPayoutSetup_Query.graphql.js';
import { type InitialState } from './reducer/state.js';
import { getStateFromUserAccount } from './utils.js';
import { graphql, useLazyLoadQuery } from '@contra/relay';
import { useEffect } from 'react';

type StateLoaderProps = {
  readonly setValue: (value: 'NOT_AVAILABLE' | InitialState) => void;
};

export const InitialStateLoader = ({ setValue }: StateLoaderProps) => {
  const query = useLazyLoadQuery<InitialStateLoaderPayoutSetup_Query>(
    graphql`
      query InitialStateLoaderPayoutSetup_Query {
        visitor {
          userAccount {
            stripeAccount {
              requiresConnectOnboardingAction
            }
            businessOperationsCountry {
              canEdit
              countryCode
            }
            payoutAccountEligibility {
              airwallexPayouts {
                airwallexBankAccountSupport
                eligibilityStatus
                prerequisite
              }
              stripeDebitCardPayouts {
                eligibilityStatus
                prerequisite
              }
              usdcPayouts {
                eligibilityStatus
                prerequisite
              }
              paypalPayouts {
                eligibilityStatus
              }
              payoneerPayouts {
                eligibilityStatus
              }
              stripeBankAccountPayouts {
                eligibilityStatus
                ... on StripeBankAccountPayoutAccountEligibility {
                  flow {
                    ... on StripeBankAccountPayoutAccountEligibilityFlowContraInApp {
                      __typename
                      prerequisiteInApp: prerequisite
                    }
                    ... on StripeBankAccountPayoutAccountEligibilityFlowStripeHosted {
                      __typename
                      prerequisiteStripeHosted: prerequisite
                    }
                  }
                }
              }
            }
            verifiedIdentity {
              location
              locationMatchesUserAccountLocation
            }
          }
        }
      }
    `,
    {},
    { fetchPolicy: 'store-and-network' },
  );

  const value = getStateFromUserAccount(query.visitor.userAccount);

  useEffect(() => {
    if (!query?.visitor?.userAccount) {
      setValue('NOT_AVAILABLE');
    } else if (!value) {
      setValue('NOT_AVAILABLE');
    } else {
      setValue(value);
    }
  }, [query, setValue, value]);

  return null;
};
